import View from './View';

export { default as getFilterButtonsData } from './utils/getFilterButtonsData';

export default View;
